<template>
  <el-dialog
    title="编辑计算规则"
    :visible.sync="isShow"
    width="600px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      :model="ruleForm"
      :rules="ruleRules"
      ref="ruleFormRef"
      label-width="120px"
    >
      <el-form-item label="规则名称" prop="ruleName">
        <el-input
          v-model="ruleForm.ruleName"
          placeholder="请输入规则名称"
          maxlength="50"
        />
      </el-form-item>

      <el-form-item label="房产类型" prop="propertyType">
        <el-select
          v-model="ruleForm.propertyType"
          placeholder="请选择房产类型"
          style="width: 100%"
          
        >
          <el-option
            v-for="(item, index) in propertyTypeOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <!-- 新增：费用类型 -->
      <el-form-item label="费用类型" prop="feeType">
        <el-select
          v-model="ruleForm.feeType"
          placeholder="请选择费用类型"
          style="width: 100%"
          
        >
          <el-option
            v-for="(item, index) in feeTypeOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="每平米价格" prop="pricePerSqm">
        <el-input
          v-model="ruleForm.pricePerSqm"
          placeholder="请输入每平米价格(元/㎡)"
          type="number"
          step="0.01"
          min="0"
        />
        <span class="unit">元/㎡</span>
      </el-form-item>

      <el-form-item label="规则描述" prop="ruleDesc">
        <el-input
          v-model="ruleForm.ruleDesc"
          placeholder="请输入规则描述"
          type="textarea"
          :rows="3"
          maxlength="500"
        />
      </el-form-item>

      <el-form-item label="是否启用" prop="isEnabled">
        <el-switch
          v-model="ruleForm.isEnabled"
          :active-value="'1'"
          :inactive-value="'0'"
          active-text="启用"
          inactive-text="禁用"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose"> 取消 </el-button>
      <el-button type="primary" @click="handleSubmit"> 确认 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCalcRuleDetail, updateCalcRule } from "@/api/community/calcRuleApi";

export default {
  name: "EditCalcRule",
  data() {
    return {
      isShow: false,
      // 表单数据：新增 feeType 字段
      ruleForm: {
        ruleId: "",
        ruleName: "",
        propertyType: "",
        feeType: "", // 新增：费用类型（rent=房租/heating=采暖）
        calculationType: "",
        pricePerSqm: 0,
        effectiveTime: "",
        expireTime: "",
        isEnabled: "",
        ruleDesc: "",
      },
      // 表单校验规则：新增 feeType 必选校验（编辑时数据已存在，校验仅兜底）
      ruleRules: {
        ruleName: [
          {
            required: true,
            message: "规则名称不能为空",
            trigger: "blur",
          },
          {
            max: 50,
            message: "规则名称长度不能超过50个字符",
            trigger: "blur",
          },
        ],
        feeType: [
          // 新增费用类型校验
          {
            required: true,
            message: "费用类型不能为空",
            trigger: "change",
          },
        ],
        pricePerSqm: [
          {
            required: true,
            message: "每平米价格不能为空",
            trigger: "blur",
          },
        ],
        effectiveTime: [
          {
            required: true,
            message: "生效时间不能为空",
            trigger: "change",
          },
        ],
      },
      // 下拉选项
      propertyTypeOptions: [
        { value: "10", label: "住宅" },
        { value: "20", label: "商业" },
        { value: "30", label: "工业" },
        { value: "40", label: "商铺" },
      ],
      // 新增：费用类型下拉选项
      feeTypeOptions: [
        { value: "rent", label: "房租" },
        { value: "heating", label: "采暖" },
      ],
      calculationTypeOptions: [
        { value: "10", label: "按面积计算" },
        { value: "20", label: "按套计算" },
        { value: "30", label: "按价格计算" },
      ],
    };
  },
  methods: {
    // 打开弹窗（接收列表页传入的规则数据）
    async open(rule) {
      this.isShow = true;
      try {
        // 加载规则详情
        const detail = await getCalcRuleDetail({
          ruleId: rule.ruleId,
        });
        console.log(detail, "detail");
        // 格式化日期 + 回显费用类型
        this.ruleForm = {
          ...detail.data,
          effectiveTime: detail.data.effectiveTime
            ? new Date(detail.data.effectiveTime)
            : "",
          expireTime: detail.data.expireTime
            ? new Date(detail.data.expireTime)
            : "",
          feeType: detail.data.feeType || "", // 回显费用类型，无数据则为空
        };
      } catch (error) {
        console.error("获取规则详情失败:", error);
        this.$message.error("获取规则详情失败，请重试");
        this.isShow = false;
      }
    },

    // 关闭弹窗
    handleClose() {
      this.isShow = false;
    },

    // 提交修改
    async handleSubmit() {
      try {
        await this.$refs.ruleFormRef.validate();
        // 调用修改接口（自动携带feeType字段）
        await updateCalcRule(this.ruleForm);
        this.$message.success("修改规则成功");
        this.isShow = false;
        this.$emit("success"); // 通知父组件刷新
      } catch (error) {
        console.error("修改规则失败:", error);
        this.$message.error("修改规则失败，请重试");
      }
    },
  },
};
</script>

<style scoped>
.unit {
  margin-left: 10px;
  color: #666;
}

.tip {
  margin-left: 10px;
  color: #999;
  font-size: 12px;
}

.dialog-footer {
  text-align: right;
}
</style>
